module.exports = __webpack_public_path__ + "img/JSB_WALLET.55a8f9ec.png";